import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let element = document.querySelector('#area');
    if (element !== null) {
        element.addEventListener('change', function (e) {
            window.location.href = e.target.value;
        });
    }
}
